import { any, either, isNil, isEmpty, values, pick } from 'ramda';

import { withEmptyRendering } from './withEmptyRendering';

type OptionalProps<T> = { [P in keyof T]: T[P] | undefined | null };

export function withEmptyRenderingStrict<T, K extends keyof T = keyof T>(keys: K[]) {
  return withEmptyRendering<Omit<T, K> & OptionalProps<Pick<T, K>>>(validator<T, K>(keys));
}

function validator<T, K extends keyof T>(keys: K[]) {
  return (props: T) => any(either(isNil, isEmpty), values(pick(keys as string[], props)));
}
